import { render, staticRenderFns } from "./TheSideBar.vue?vue&type=template&id=6ebfdb34&scoped=true"
import script from "./TheSideBar.vue?vue&type=script&lang=js"
export * from "./TheSideBar.vue?vue&type=script&lang=js"
import style0 from "./TheSideBar.vue?vue&type=style&index=0&id=6ebfdb34&prod&lang=scss&scoped=true"
import style1 from "./TheSideBar.vue?vue&type=style&index=1&id=6ebfdb34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebfdb34",
  null
  
)

export default component.exports